
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const useWintersportData = (searchTerm: string, countryFilter: string, priceFilter: string) => {
  const [vacations, setVacations] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [countries, setCountries] = useState<string[]>([]);

  const fetchCountries = async () => {
    try {
      const { data, error } = await supabase
        .from('Complete feed')
        .select('country')
        .not('country', 'is', null)
        .or('name.ilike.%wintersport%,description.ilike.%wintersport%,specialCategories.ilike.%wintersport%,name.ilike.%ski%,description.ilike.%ski%,name.ilike.%snowboard%,description.ilike.%snowboard%');
      
      if (error) throw error;
      
      const uniqueCountries = [...new Set(data.map(item => item.country))].sort();
      setCountries(uniqueCountries);
    } catch (error: any) {
      console.error('Error fetching countries:', error);
    }
  };

  const fetchVacations = async () => {
    setLoading(true);
    try {
      let query = supabase
        .from('Complete feed')
        .select('*')
        .not('imageURL', 'is', null)
        .not('name', 'is', null);

      // Filter for wintersport related vacations
      const wintersportConditions = [
        'name.ilike.%wintersport%',
        'description.ilike.%wintersport%',
        'specialCategories.ilike.%wintersport%',
        'typeVakantie.ilike.%wintersport%',
        'name.ilike.%ski%',
        'description.ilike.%ski%',
        'name.ilike.%snowboard%',
        'description.ilike.%snowboard%',
        'name.ilike.%après%',
        'description.ilike.%après%',
        'name.ilike.%piste%',
        'description.ilike.%piste%',
        'facilities.ilike.%ski%',
        'facilities.ilike.%snowboard%'
      ];

      query = query.or(wintersportConditions.join(','));

      if (searchTerm) {
        query = query.or(`name.ilike.%${searchTerm}%,description.ilike.%${searchTerm}%,city.ilike.%${searchTerm}%`);
      }

      if (countryFilter !== "all") {
        query = query.eq('country', countryFilter);
      }

      if (priceFilter !== "all") {
        if (priceFilter === 'onbekend') {
          query = query.or('price.is.null,price.eq.0');
        } else if (priceFilter === '500') {
          query = query.gt('price', 0).lt('price', 500);
        } else if (priceFilter === '1000') {
          query = query.gte('price', 500).lt('price', 1000);
        } else if (priceFilter === '2000') {
          query = query.gte('price', 1000).lt('price', 2000);
        } else if (priceFilter === '2000+') {
          query = query.gte('price', 2000);
        }
      }

      const { data, error } = await query.limit(100);
      
      if (error) throw error;
      
      console.log('Wintersport data loaded from Complete feed:', data?.length || 0, 'items');
      setVacations(data || []);
    } catch (error: any) {
      toast.error("Fout bij het laden van wintersport vakanties");
      console.error('Error fetching wintersport vacations:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCountries();
  }, []);

  useEffect(() => {
    const delayedSearch = setTimeout(() => {
      fetchVacations();
    }, 300);

    return () => clearTimeout(delayedSearch);
  }, [searchTerm, countryFilter, priceFilter]);

  return {
    vacations,
    loading,
    countries
  };
};
